export default "/_next/static/chunks/fonts/Play Bold-b78f3be6adabf73cde7f97e0e400232f.ttf";